import BaseBreadcrumb from './base-breadcrumb';

export default BaseBreadcrumb;
